import { Agp } from "../api/agp";

export type AgpState = "unreleased" | "released" | "sold";

export function getAgpState(agp: Agp): AgpState {
  if (!agp.releasedDate) return "unreleased";
  if (agp.sold && agp.sold > 0) return "sold";
  return "released";
}